import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import CircularProgress from '@material-ui/core/CircularProgress';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import InputLabel from '@material-ui/core/InputLabel';
import CardActions from '@material-ui/core/CardActions';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const styles = theme => ({
    root: {
        width: '95%',
        minWidth: '150px',
        height: '500px',
        minHeight: '350px',
        //overflowX: 'auto',
        //display: 'column',
        alignItem: 'center',
        margin: '0 Auto',
    },
    formControl: {
        margin: theme.spacing.unit * 3,
    },
    group:{
    },
    radio: {
        '&$checked' : {
            color: '#B71C1C',
        },
    },
    checked: {},
    progress: {
        /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
        flexDirection: 'column',
        margin: theme.spacing.unit * 3,
    },
    button:{
        display:'flex',
        //justifyContent: 'center',
        margin: '0 Auto',
    },
    InputLabel:{
        fontSize: '14px',
    },
    rightInput:{
        marginLeft: '50px',
    },
    country:{
        marginTop: '15px',
        marginBottom: '10px',
    },
    hkidPassport:{
        marginTop: '15px',
        marginBottom: '10px',
    },
});

class ChangePassword extends Component {
    state = {
      currentPassword: null,
      showCurrentPassword: false,
      newPassword: null,
      showNewPassword: false,
      confirmNewPassword: null,
      showConfirmNewPassword: false,
      newPasswordNotMatch: false,
    };

    componentDidMount(){
        
        // setTimeout(()=>{
        //     this.props.getUserInformation(localStorage.getItem('token'));
        // },500)
        
        console.log('changePassword: did mount')
        //this.props.onUserInfoRef(this);
        this.setState({ currentPassword: this.props.password });
        // this.props.resetChangePassword()

    }
    componentWillUnmount() {
        console.log('changePassword: did unmount')
        //this.props.onUserInfoRef(undefined);
      }

    handleChange = prop => event => {
        this.setState({ [prop]: event.target.value });
    }
    
    handleClickShowPassword = (prop) => {
        console.log('handleClickShowPassword: '+prop +' '+!this.state[prop])
        this.setState({ [prop]: !this.state[prop] });
    };

    submitHandler = (event) => {
        event.preventDefault();
        //this.updateUserInfoSubmitHandler();
    };

    changePasswordSubmitHandler = () => {
        // let userPassword = {
        //     currentPassword: this.state.currentPassword,
        //     newPassword: this.state.newPassword,
        //     refToken: localStorage.getItem('token'),
        // }
        console.log('changePasswordSubmitHandler newPassword: '+this.state.newPassword+' confirmNewPassword: '+this.state.confirmNewPassword+' currentPassword: '+this.state.currentPassword);

        if (this.state.newPassword === this.state.confirmNewPassword){

            console.log('changePasswordSubmitHandler password matching')
            this.setState({
                newPasswordNotMatch:false
            });
            
            this.props.changePassword(localStorage.getItem('token'), this.state.currentPassword, this.state.newPassword)
            console.log('changePasswordSubmitHandler newPasswordNotMatch: '+this.state.newPasswordNotMatch)
        }
        else{

            console.log('changePasswordSubmitHandler password not matching')
            this.setState({
                newPasswordNotMatch:true
            })
            console.log('changePasswordSubmitHandler newPasswordNotMatch: '+this.state.newPasswordNotMatch)

        }
        //this.props.updateUserInfo(userData, this.props.handleComplete);
    }

    render(){
        const { classes } = this.props;
        return(
            <form className={classes.root} onSubmit={this.submitHandler}>
                <Card className={classes.card}>
                    <CardContent>
                        <FormControl className={classes.margin} required fullWidth>
                            { (this.state.newPasswordNotMatch == true) && <label style={{ fontSize: '12px'}} > New Password not matching. Please retry again.</label> }
                            { this.props.changePasswordSuccess && <label style={{ fontSize: '12px'}} > Password change successful.</label> }

                            <InputLabel style={{ fontSize: '14px'}} htmlFor="current-password" /* error={this.props.error} */ >Current Password</InputLabel>
                            <Input
                                id="current-password"
                                type={this.state.showCurrentPassword ? 'text' : 'password'}
                                value={this.state.password}
                                // error={this.props.error}
                                onChange={this.handleChange('currentPassword')}
                                disabled={this.props.loginInProgress}
                                endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                    style={{fontSize: '14px'}}
                                    aria-label="Toggle password visibility"
                                    onClick={() => this.handleClickShowPassword('showCurrentPassword')}
                                    >
                                    {this.state.showCurrentPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                                }
                                // inputLabelProps={{
                                    // style: {fontSize: 14},
                                    //shrink: true,
                                // }}
                                // inputProps={{
                                    // style: {fontSize: 14},
                                    //shrink: true,
                                // }}
                                
                            />
                            </FormControl>
                            <FormControl className={classes.margin} required fullWidth>
                            <InputLabel style={{fontSize: '14px'}} htmlFor="new-password" error={this.props.error}>New Password</InputLabel>
                            <Input
                                id="new-password"
                                type={this.state.showNewPassword ? 'text' : 'password'}
                                value={this.state.password}
                                // error={this.props.error}
                                onChange={this.handleChange('newPassword')}
                                disabled={this.props.loginInProgress}
                                endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                    style={{fontSize: '14px'}}
                                    aria-label="Toggle password visibility"
                                    onClick={() => this.handleClickShowPassword('showNewPassword')}
                                    >
                                    {this.state.showNewPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                                }
                                // inputLabelProps={{
                                //     style: {fontSize: 14},
                                //     //shrink: true,
                                // }}
                                // inputProps={{
                                //     style: {fontSize: 14},
                                //     //shrink: true,
                                // }}
                                
                            />
                            </FormControl>
                            <FormControl className={classes.margin} required fullWidth>
                            <InputLabel style={{fontSize: '14px'}} htmlFor="confirm-new-password" error={this.props.error}>Confirm New Password</InputLabel>
                            <Input
                                id="confirm-new-password"
                                type={this.state.showConfirmNewPassword ? 'text' : 'password'}
                                value={this.state.password}
                                // error={this.props.error}
                                onChange={this.handleChange('confirmNewPassword')}
                                disabled={this.props.loginInProgress}
                                endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                    style={{fontSize: '14px'}}
                                    aria-label="Toggle password visibility"
                                    onClick={() => this.handleClickShowPassword('showConfirmNewPassword')}
                                    >
                                    {this.state.showConfirmNewPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                                }
                                inputLabelProps={{
                                    style: {fontSize: 14},
                                    //shrink: true,
                                }}
                                inputProps={{
                                    style: {fontSize: 14},
                                    //shrink: true,
                                }}
                                
                            />
                        </FormControl>         
                    </CardContent>
                    <CardActions>
                        {
                            this.props.isLoadingUpdate ?  
                            <div className={classes.button}>
                                <CircularProgress size={25} thickness={2} className={classes.loading}/>
                            </div>
                             :
                            <Button
                                variant="contained"
                                type="submit"
                                color="primary"
                                disabled={this.props.changePasswordSuccess}
                                className={classes.button}
                                onClick={() => this.changePasswordSubmitHandler()} >
                                Save
                            </Button>

                        }
                    </CardActions>                
                </Card>
            </form>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        fullName: (state.caseInfo.userType !== null || state.caseInfo.userType !== undefined)  ? (state.caseInfo.userType === 'claimant' ? state.caseInfo.claimant_name : state.caseInfo.respondent_name) : '',
        // password: state.userInfo.password,
        error: state.userInfo.error,
        isLoadingUpdate: state.userInfo.isLoadingUpdate,
        changePasswordSuccess: state.auth.changePassword,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateUserInfo: (userData, handleComplete) => dispatch(actions.updateUserInfo(userData, handleComplete)),
        getUserInformation: (uniqueId) => dispatch(actions.getUserInformation(uniqueId)),
        changePassword: (uniqueId, currentPassword, newPassword) => dispatch(actions.changePassword(uniqueId, currentPassword, newPassword)),
        resetChangePassword: () => dispatch(actions.resetChangePassword()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(ChangePassword)));
